import http from "@/utils/axios";
import { Toast } from 'vant';
const publicFunc = {
    loading:false,
    getJumpSingeOrTeam: function (parmes) {
        if(publicFunc.loading){
            Toast('提交过于频繁')
            return
        }
        publicFunc.loading = true;
        http({
            url: "/order/teamchat/getBranchChatType",
            method: "post",
            parmes: parmes.statusParmes
        }).then(rps => {
            if (rps.code == 200) {
                if (rps.data.isTeamChat) {
                    publicFunc.getTeamChatId(parmes.teamParmes, function (teamParmes) {
                        parmes.callback(rps.data, teamParmes)
                    })
                } else {
                    parmes.callback(rps.data,{})
                }
            } else {
                parmes.callback({},{})
            }
        }).catch(err => {
            parmes.callback({},{})
        })
        setTimeout(()=>{
          publicFunc.loading = false;
        },2000)
    },
    getTeamChatId: function (teamParmes, callback = function () {}) {
        http({
            url: "/order/teamchat/branchTeamChat",
            method: "post",
            parmes: teamParmes
        }).then(rps => {
            callback(rps.data)
        }).catch(err => {
            callback()
        })
    }
}

export default publicFunc;